import { push } from 'connected-react-router';
import type { ConnectedProps } from 'react-redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import { medications, PromotionalLandingPage } from 'src/app/router/paths';
import { pushWithQueryParams } from 'src/app/state/actions';
import { isLoggedIn } from 'src/app/state/selectors';
import type { Dispatch, RootState } from 'src/app/state/store';

import type { MultiReferralPromo } from '../constants';

import { RedirectToPromoPageRenderer } from '.';

const mapStateToProps = (state: RootState) => ({
  isLoggedIn: isLoggedIn(state),
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  redirectToLoggedInHome: () => dispatch(push(medications.toPath())),
  redirectToPromoPage: (promoCode: string, multiReferralPromoCode?: MultiReferralPromo) => {
    const searchParams = {};
    let promoCodeToUse;

    if (multiReferralPromoCode) {
      // Single promo page used for multiple referrals
      // promoCode used as referral
      // https://capsulerx.atlassian.net/wiki/spaces/CA/pages/2904555521/Using+multiple+referrals+on+promo+landing+pages
      searchParams['referral'] = promoCode;
      promoCodeToUse = multiReferralPromoCode;
    } else {
      promoCodeToUse = promoCode;
    }

    dispatch(pushWithQueryParams(PromotionalLandingPage.toPath({ promo_code: promoCodeToUse }), searchParams));
  },
});

const connector = connect(mapStateToProps, mapDispatchToProps);
export type PropsFromRedux = ConnectedProps<typeof connector>;

export const RedirectToPromoPage = withRouter(connector(RedirectToPromoPageRenderer));
